export enum ChatDocumentType {
  PDF = 'pdf',
  CSV = 'csv',
  TXT = 'txt',
  XLSX = 'xlsx',
  DOCX = 'docx',
}

export enum ChatDocumentUploadErrorCode {
  INVALID_TYPE = 'invalid_type',
  TOO_LARGE = 'too_large',
  TOO_MANY_PAGES = 'too_many_pages',
  TOO_MANY_SHEETS = 'too_many_sheets',
  TOO_MANY_ROWS = 'too_many_rows',
  TOO_MANY_CELLS = 'too_many_cells',
  PASSWORD_PROTECTED = 'password_protected',
  UNREADABLE = 'unreadable',
  DAILY_LIMIT = 'daily_limit',
  UPLOAD_FAILED = 'upload_failed',
}
